import React from 'react'

const ErrorPage = () => {
  return (
    <div>You were not supposed to be here!</div>
  )
}

export default ErrorPage